import applyMiddleware from '../apply-middleware';

/**
 * Initializes an analytics instance and applies middleware.
 *
 * @note This should only be called once per pageload.
 * @see https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/quickstart/#step-2b-install-segment-as-a-npm-package
 */
function initializeAnalytics(
  analytics,
  writeKey,
  options,
  supplementalContextHelpers
) {
  // Defense for empty write key string
  if (!writeKey) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(
        'No write key provided to analytics. This will result in no data being sent to Segment.'
      );
    }

    return;
  }

  analytics.load(
    { writeKey },
    {
      ...options,
      integrations: {
        'Segment.io': {
          deliveryStrategy: {
            config: {
              keepalive: true,
            },
          },
        },
        ...options?.integrations,
      },
    }
  );

  applyMiddleware(analytics, supplementalContextHelpers);
}

export default initializeAnalytics;
